import { useAdminDepartureOwner } from "@/routing/useAdminDepartureOwner";

/** Participate in the shared decision without disposing this draft on consent. */
export function useGrowthFormNavigationGuard({
  when,
  busy,
  revision = "",
  readRevision,
}: {
  when: boolean;
  busy: boolean;
  revision?: string;
  readRevision?: () => string;
}) {
  const owner = useAdminDepartureOwner({ when, busy, revision, readRevision });
  return {
    pendingNavigation: owner.promptOpen ? {} : null,
    navigationBusy: busy,
    cancelPendingNavigation: owner.cancel,
    confirmPendingNavigation: owner.approve,
    suspendPendingNavigation: owner.suspend,
    retryPendingNavigationWhenReady: owner.retryWhenReady,
  };
}
